import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiGet, apiPost } from "../api";

export default function InvoiceConflictPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [inv, setInv] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { apiGet(`/api/invoices/${id}/`).then(setInv); }, [id]);
  if (!inv) return <div style={{ padding: 24 }}>Loading…</div>;

  const resolve = async (winner) => {
    setBusy(true);
    await apiPost(`/api/quickbooks/invoices/${id}/resolve_conflict/`, { winner });
    navigate(`/invoices/${id}`);
  };

  return (
    <div style={{ padding: 24 }}>
      <h1>Sync conflict — invoice {inv.number}</h1>
      <p>This invoice was changed in QuickBooks after ClientZone last synced it. Choose which version wins.</p>
      <div style={{ display: "flex", gap: 24 }}>
        <div style={{ flex: 1, border: "1px solid #e5e7eb", padding: 16 }}>
          <h2>ClientZone</h2>
          <p>Total: {inv.total}</p>
          <ul>{(inv.lines || []).map((l, i) => <li key={i}>{l.description} — {l.amount}</li>)}</ul>
        </div>
        <div style={{ flex: 1, border: "1px solid #e5e7eb", padding: 16 }}>
          <h2>QuickBooks</h2>
          <p>QuickBooks holds a newer version (DocNumber {inv.qbo_doc_number}).</p>
        </div>
      </div>
      <div style={{ marginTop: 16 }}>
        <button disabled={busy} onClick={() => resolve("clientzone")}>
          Keep ClientZone version (overwrite QuickBooks)
        </button>{" "}
        <button disabled={busy} onClick={() => resolve("quickbooks")}>
          Accept QuickBooks version
        </button>
      </div>
    </div>
  );
}
